var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBracketLightMode = function SvgBracketLightMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 118,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bracket_light_mode_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bracket_light_mode_svg__b)",
    d: "M44.288 98q-5.442 0-8.854-1.332-3.33-1.248-4.874-3.83-1.462-2.496-1.462-6.326v-15.4q0-4.662-2.112-6.66-2.031-1.997-6.986-1.997v-6.826q4.955 0 6.986-1.998 2.112-1.998 2.112-6.66V31.488q0-3.83 1.462-6.327 1.544-2.58 4.874-3.83 3.412-1.33 8.854-1.331v6.493q-4.142 0-5.93 1.249-1.706 1.248-1.706 3.912V48.22q0 4.412-2.274 7.076-2.193 2.664-6.58 3.746 4.387.998 6.58 3.662 2.274 2.664 2.274 7.076v16.566q0 2.664 1.706 3.912 1.788 1.25 5.93 1.249z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bracket_light_mode_svg__c)",
    d: "M55 43.256c0 3.28-2.594 5.938-5.794 5.938s-5.795-2.658-5.795-5.938 2.594-5.938 5.795-5.938S55 39.977 55 43.256"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bracket_light_mode_svg__b",
    x1: 25.487,
    x2: 65.119,
    y1: 187.527,
    y2: 185.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05DF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#96C5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bracket_light_mode_svg__c",
    x1: 25.487,
    x2: 65.119,
    y1: 187.527,
    y2: 185.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05DF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#96C5F0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bracket_light_mode_svg__a",
    width: 75,
    height: 118,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2787_317131"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2787_317131",
    result: "shape"
  })))));
};
export default SvgBracketLightMode;